# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(document).on 'turbolinks:load', ->
  
  # Activating Best In Place 
  jQuery(".best_in_place").best_in_place()
  return
  
  $('.best_in_place').bind 'ajax:success', ->
    $(this).closest('tr').effect 'highlight'
    return
  
